export class GroupModel {
  groupId: number = 0;
  code: string = '';
  name: string = '';
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
